import { Modules } from '@app/core/enums';
import { ExportParams } from '@app/core/models/common';

export class UpdateThemeColor {
  static readonly type = '[COLOR] Update Theme Color';

  constructor(public colorCode: string) {}
}
export class Preview {
  static readonly type = '[PREVIEW] Preview';

  constructor(public exportParams: ExportParams, public moduleId: Modules) {}
}

export class GetReplyToCCAddresses {
  static readonly type = '[EMAIL] Get Reply To CC Addresses';
}

export class GetEmailNotificationSettings {
  static readonly type = '[EMAIL] Get Email Notification Settings';
}

export class SaveEmailNotificationSettings {
  static readonly type = '[EMAIL] Save Email Notification Settings';

  constructor(public payload: { moduleId: number; displayName: string; ccAddress: string; replyToAddress: string }) {}
}

export class ResetEmailNotificationSettings {
  static readonly type = '[EMAIL] Reset Email Notification Settings';

  constructor(public moduleId: number) {}
}
